import React from 'react'
import Home from '../Components/About-Us/Home/Home'
import CompanyStory from '../Components/About-Us/CompanyStory/CompanyStory'
import Stats from '../Components/About-Us/Stats/Stats'
import Vision from '../Components/About-Us/Vision-Mission/Vision'
import OurValue from '../Components/About-Us/Our-Values/OurValue'
import Certificate from '../Components/About-Us/Certificate/Certificate'

const AboutPage = () => {
  return (
    <>
        <Home />
        <CompanyStory />
        <Stats />
        <Vision />
        <OurValue />
        <Certificate />
    </>
  )
}

export default AboutPage